export var singleAxis = { top: 10, left: 40, right: 4, bottom: 85 }
export var doubleAxis = { top: 10, left: 40, right: 40, bottom: 85 }
export var noDataZoomAxis = { top: 10, left: 40, right: 4, bottom: 55 }
export var noDataZoomDoubleAxis = { top: 10, left: 40, right: 40, bottom: 55 }
